<template>
  <v-card>
    <div>
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{userType.name}}
          </div>
        </div>
        <div>
          <ButtonActionEdit @click="$emit('edit')" />
          <ButtonActionDelete @click="$emit('delete')" />
        </div>
      </div>
      <v-card-text>
        <h3>Pravice:</h3>
        <p>
          Ponovno tiskanje: <ActiveIcon :value="userType.repeat_print_permission" />
        </p>
        <p>
          Dodajanje popusta: <ActiveIcon :value="userType.discount_permission" />
        </p>
        <p>
          Pregled statistike prodaje: <ActiveIcon :value="userType.sales_log_permission" />
        </p>
        <p>
          Storno račun: <ActiveIcon :value="userType.negative_amount_permission" />
        </p>
        <p>
          Brisanje mize: <ActiveIcon :value="userType.clear_table_permission " />
        </p>
        <div class="subtitle" v-if="applicationPermsLength">
          Aplikacija
        </div>
        <p v-for="setting in userType.settings.filter(setting => setting.relevance === 2)">
          {{appropriateName(setting.key)}}:
          <ActiveIcon :value="setting.value" />
          <span v-if="parseInt(setting.value)">({{ setting.value }})</span>
        </p>
        <div class="subtitle" v-if="cmsPermsLength">
          Spletna pisarna
        </div>
        <p v-for="setting in userType.settings.filter(setting => setting.relevance === 1)">
          {{appropriateName(setting.key)}}:
          <ActiveIcon :value="setting.value" />
          <span v-if="parseInt(setting.value)">({{ setting.value }})</span>
        </p>

      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ActiveIcon from './ActiveIcon'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ActiveIcon
  },
  computed: {
    applicationPermsLength () {
      if (this.userType.settings && this.userType.settings.length) {
        return this.userType.settings.filter(setting => setting.relevance === 2) && this.userType.settings.filter(setting => setting.relevance === 2).length
      }
      return 0
    },
    cmsPermsLength () {
      if (this.userType.settings && this.userType.settings.length) {
        return this.userType.settings.filter(setting => setting.relevance === 1) && this.userType.settings.filter(setting => setting.relevance === 1).length
      }
      return 0
    }
  },
  props: {
    userType: {
      required: true,
      type: Object
    }
  },
  methods: {
    appropriateName (key) {
      switch(key) {
        case 'permission_canceled_tables_log':
          return 'Preklicane mize'
        case 'permission_currentstock_log':
          return 'Trenutna zaloga'
        case 'permission_num_last_invoices':
          return 'Št. zadnjih računov'
        case 'permission_revert_invoice_timeout':
          return 'Čas storniranja računa'
        case 'permission_print_table':
          return 'Tiskaj mizo'
        case 'permission_allow_ordering':
          return 'Naročila'
        case 'permission_payment_type_with_discount':
          return 'Plačilno sredstvo s popustom'
        case 'permission_allow_print_invoices_report':
          return 'Izpis računov'
        case 'permission_transfer_table':
          return 'Prenašanje miz'
        case 'permission_allow_deleting_saved_articles':
          return 'Brisanje shranjenih artiklov'
        case 'permission_allow_negative_articles':
          return 'Vnos negativne količine artiklov'
        case 'permission_create_temporary_table':
          return 'Nova začasna miza'
        case 'permission_end_active_tables_before_shift_start':
          return 'Pred zaključkom izmene zaključi vse mize'
        case 'permission_setting_enabled':
          return 'Nastavitve'
        case 'permission_ellypos_application_integration':
          return 'Integracija plačil'
        case 'permission_modify_application_look':
          return 'Izgled'
        case 'permission_setting_invoices':
          return 'Računi'
        case 'permission_setting_skip_fiscalization':
          return 'Preskoči fiskalizacijo'
        case 'permission_setting_tables':
          return 'Mize'
        case 'permission_setting_ordering':
          return 'Naročila'
        case 'permission_setting_other':
          return 'Ostalo'
        case 'permission_setting_own_invoices':
          return 'Samo računi uporabnika'
        case 'permission_setting_see_own_open_tables':
          return 'Ne prikazuj miz ostalih uporabnikov'
        case 'permission_sales_articles_log':
          return 'Promet po artiklih'
        case 'permission_setting_cms_enabled':
          return 'Spletna pisarna'
        case 'permission_sales_log':
          return 'Dnevnik prodaje'
        case 'permission_salesman_sales_log':
          return 'Promet prodajalca'
        case 'permission_cms_invoice_history':
          return 'Zadnji računi'
        case 'permission_cms_invoice_history_update':
          return 'Spremeni'
        case 'permission_cms_invoice_history_revert':
          return 'Storno'
        case 'permission_cms_invoice_history_print_or_copy':
          return 'Tiskaj A4/PDF / kopija računa'
        case 'permission_cms_logs':
          return 'Izpisi'
        case 'permission_cms_sales_log':
          return 'Dnevnik prodaje'
        case 'permission_cms_salesman_log':
          return 'Promet prodajalca'
        case 'permission_cms_articles_log':
          return 'Promet po artiklih'
        case 'permission_cms_worktime_log':
          return 'Delovni čas'
        case 'permission_cms_controltape_log':
          return 'Kontrolni trak'
        case 'permission_cms_other_enums':
          return 'Ostali Šifranti'
        case 'permission_cms_other_enums_groups':
          return 'Skupine'
        case 'permission_cms_other_enums_levels':
          return 'Nivoji'
        case 'permission_cms_other_enums_places':
          return 'Prostori'
        case 'permission_cms_other_enums_tables':
          return 'Mize'
        case 'permission_cms_other_enums_print_locations':
          return 'Lokacije tiskalnikov'
        case 'permission_cms_other_enums_groups_main':
          return 'Grupe'
        case 'permission_cms_other_enums_user_permissions':
          return 'Pravice uporabnikov'
        case 'permission_cms_other_enums_payment_types':
          return 'Tipi plačila'
        case 'permission_cms_other_enums_comments':
          return 'Opombe'
        case 'permission_cms_other_enums_price_levels':
          return 'Nivoji cen'
        case 'permission_cms_material_management':
          return 'Materialno poslovanje'
        case 'permission_cms_material_management_current_stock':
          return 'Trenutna zaloga'
        case 'permission_cms_material_management_acceptance_form':
          return 'Prevzemnice'
        case 'permission_cms_material_management_writeoff_forms':
          return 'Odpis'
        case 'permission_cms_material_management_inventory_forms':
          return 'Inventura'
        case 'permission_cms_material_management_analytics_forms':
          return 'Analitika'
        case 'permission_cms_home':
          return 'Domov'
        case 'permission_cms_ordering_history':
          return 'Zadnja naročila'
        case 'permission_cms_articles':
          return 'Artikli'
        case 'permission_cms_users':
          return 'Uporabniki'
        case 'permission_cms_clients':
          return 'Klienti'
        /* case 'permission_test_false':
          return 'Testni permisija (default false)'
        case 'permission_test_true':
          return 'Testni permisija (default true)'
        case 'permission_test2_false':
          return 'Testni permisija (default false)'
        case 'permission_test2_true':
          return 'Testni permisija2 (default true)' */
        default:
          return 'Nevpisana vrednost'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }

  }
  .subtitle {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    color: #607d8b4f;
  }
  .v-card__text {
    h3 {
      color: #37474F;
      margin: 10px 0;
    }
    p {
      margin: 0;
      padding: 0;
      .v-icon {
        font-size: 20px;
      }
    }
  }
</style>
